import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserWorkspace = React.lazy(() =>
    import('../UserWorkspace')
);
const userWorkspaceRoutesRegistry = [
    {
        path: PAGE_URL.USER_WORKSPACE_PAGE,
        element: <UserWorkspace />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userWorkspaceRoutesRegistry;
